<template>
  <book-widget-frame
    :link="link"
  />
</template>

<script>
import BookWidgetFrame from '../../components/Homework/BookWidgetFrame.vue';

export default {
  name: 'BookWidgetView',

  components: {
    BookWidgetFrame,
  },

  computed: {
    link() {
      return `${this.$route.params.homeworkId}`;
    },
  },
};
</script>
